import { GROUPS, PREFIX } from '@/service/apiConf';
import { getCurrDataCenter, getUrlWorkspace } from '@/service/index';
import { get, postJSON } from '@/service/request';

interface ResourceType {
  resource: string;
  verbs: string[];
}
interface GroupType {
  group: string;
  resources: ResourceType[];
}
interface NamespaceType {
  namespace: string;
  groups: GroupType[];
}

interface GetTempTokenParams {
  accessTokentTimeout: number; // 访问令牌过期时间，单位秒, 默认30分钟
  namespaces: NamespaceType[]; // 命名空间
  dataCenter?: string; // 数据中心
  refreshTokenTimeout?: number; // 刷新令牌过期时间, 0表示不允许访问, 默认0
  workspace?: string; // 租户
}

interface GetTempTokenResponse {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  tokenType: string;
}

export interface GenerateApiTokenParams {
  dataCenter?: string;
  group: string;
  namespace: string;
  /** 相对代理路径，如 modelinstances/{name}/services/{service}/v1/chat/completions */
  path: string;
  resource: string;
  verb: string;
  workspace?: string;
}

export interface GenerateApiTokenResponse {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
}

// 获取临时token
export function getTempToken({
  namespaces,
  dataCenter,
  workspace,
  refreshTokenTimeout = 0,
  accessTokentTimeout = 1800,
}: GetTempTokenParams) {
  workspace = workspace || getUrlWorkspace();
  dataCenter = dataCenter || getCurrDataCenter();
  return postJSON<GetTempTokenResponse>(`${PREFIX.vapis(GROUPS.iam)}/generatetoken`, {
    accessTokentTimeout,
    namespaces,
    dataCenter,
    refreshTokenTimeout,
    workspace,
  });
}

/** 生成远程访问 API 代理令牌 */
export function generateApiToken({ dataCenter, workspace, ...rest }: GenerateApiTokenParams) {
  return postJSON<GenerateApiTokenResponse>(`${PREFIX.vapis(GROUPS.iam)}/generateapitoken`, {
    ...rest,
    dataCenter: dataCenter || getCurrDataCenter(),
    workspace: workspace || getUrlWorkspace(),
  });
}

// 上传文件通用的token获取
export const UrlMap = () => {
  return {
    /** 镜像等制品上传 STS */
    uploadToken: (username) => `${PREFIX.vapis_dc_ws(GROUPS.image)}/sts-credentials?username=${username}`,
    /** 运营产品图等 ophub S3 凭证（数据中心前缀） */
    uploadImgToken: (username) => `${PREFIX.vapis_dc_ws(GROUPS.ophub)}/s3-credentials?username=${username}`,
    /** 系统运营中心产品类别图等 ophub S3 凭证（全局前缀） */
    uploadImgTokenGlobal: (username) => `${PREFIX.vapis(GROUPS.ophub)}/s3-credentials?username=${username}`,
  };
};

// 文件上传token
export function getUploadFileToken(name) {
  return get(UrlMap().uploadToken(name));
}

/** 图片上传 token（ophub s3-credentials，数据中心） */
export function getUploadImgToken(name) {
  return get(UrlMap().uploadImgToken(name));
}

/** 图片上传 token（ophub s3-credentials，全局） */
export function getUploadImgTokenGlobal(name) {
  return get(UrlMap().uploadImgTokenGlobal(name));
}
